module.exports = __webpack_public_path__ + "static/media/3.b1a0eabb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/mogilev/3.jpg
// module id = 236
// module chunks = 0